module.exports = __webpack_public_path__ + "media/online_learning/resource-02-62500126.png";